module.exports = __webpack_public_path__ + "img/logoviejo.673ef4ac.png";